import { Icon } from '@assembly-js/design-system';

// The help center rows previously mixed hairline outline icons with a couple of
// solid ones, so the list read unevenly. These are the design-system glyphs at
// the same 14px the sidebar nav uses, so the weight matches throughout.
const HELP_CENTER_ICON_SIZE = 14;

const iconProps = {
  width: HELP_CENTER_ICON_SIZE,
  height: HELP_CENTER_ICON_SIZE,
};

export const HelpCenterHelpDeskIcon = () => (
  <Icon icon="Helpdesk" {...iconProps} />
);
export const HelpCenterCommunityIcon = () => (
  <Icon icon="CommentDots" {...iconProps} />
);
export const HelpCenterSupportIcon = () => (
  <Icon icon="SquareQuestion" {...iconProps} />
);
export const HelpCenterUpdatesIcon = () => (
  <Icon icon="Newspaper" {...iconProps} />
);
export const HelpCenterShortcutsIcon = () => (
  <Icon icon="Stopwatch" {...iconProps} />
);
export const HelpCenterReferralsIcon = () => (
  <Icon icon="Gift" {...iconProps} />
);
